import { render } from "./CollectYourBadgeView.vue?vue&type=template&id=0b5e94b0"
import script from "./CollectYourBadgeView.vue?vue&type=script&lang=js"
export * from "./CollectYourBadgeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__